export const environment = {
  production: true,
  apiUrl: 'https://api-v4.eyezilla.ai/api',
  grafanaUrl: 'https://api-v4.eyezilla.ai/grafana',
  grafanaLiveScreenUrl: 'https://api-v4.eyezilla.ai/grafana-v6',
};
